import { AnnouncementBadge } from "@/components/marketing/elements/announcement-badge"
import { ButtonLink, PlainButtonLink } from "@/components/marketing/elements/button"
import { ArrowNarrowRightIcon } from "@/components/marketing/icons/arrow-narrow-right-icon"
import { MarketingLayout } from "@/components/marketing/MarketingLayout"
import { ResponsiveAppScreenshot } from "@/components/marketing/ResponsiveAppScreenshot"
import { HeroLeftAlignedWithDemo } from "@/components/marketing/sections/hero-left-aligned-with-demo"
import { MarketingAgentSection } from "@/components/marketing/sections/MarketingAgentSection"
import { MarketingAudienceSection } from "@/components/marketing/sections/MarketingAudienceSection"
import { MarketingCta } from "@/components/marketing/sections/MarketingCta"
import { MarketingFaqsTwoColumn } from "@/components/marketing/sections/MarketingFaqsSection"
import { MarketingOwnershipSection } from "@/components/marketing/sections/MarketingOwnershipSection"
import { DynamicPricingSection } from "@/components/marketing/sections/DynamicPricingSection"
import { MarketingProductFeatures } from "@/components/marketing/sections/MarketingProductFeatures"
import { MarketingProductModelStats } from "@/components/marketing/sections/MarketingProductModelStats"
import { MarketingWhySection } from "@/components/marketing/sections/MarketingWhySection"
import { PRODUCT_SUMMARY, PRODUCT_TAGLINE, TRUST_STRIP_ITEMS } from "@/content/marketing/site-content"
import { primaryCtaHref, primaryCtaLabel, waitlistHref, waitlistLabel } from "@/lib/launch-config"

export function LandingPage() {
  return (
    <MarketingLayout>
      <HeroLeftAlignedWithDemo
        id="hero"
        eyebrow={<AnnouncementBadge text="Limited availability" />}
        headline={PRODUCT_TAGLINE}
        subheadline={<p>{PRODUCT_SUMMARY}</p>}
        cta={
          <div className="flex flex-col gap-4">
            <div className="flex flex-wrap items-center gap-4">
              <ButtonLink href={primaryCtaHref()} size="lg">
                {primaryCtaLabel()}
              </ButtonLink>
              <PlainButtonLink href="#features" size="lg">
                See how it works <ArrowNarrowRightIcon />
              </PlainButtonLink>
              <PlainButtonLink href={waitlistHref()} size="lg">
                {waitlistLabel()}
              </PlainButtonLink>
            </div>
            <p className="text-sm/7 text-mauve-500 dark:text-mauve-500">
              {TRUST_STRIP_ITEMS.join(" · ")}
            </p>
          </div>
        }
        demo={<ResponsiveAppScreenshot shot="explore" wallpaper="purple" placement="bottom" />}
      />

      <MarketingProductFeatures />
      <MarketingOwnershipSection />
      <MarketingAgentSection />
      <MarketingProductModelStats />
      <MarketingAudienceSection />
      <MarketingWhySection />
      <DynamicPricingSection />
      <MarketingFaqsTwoColumn />

      <MarketingCta />
    </MarketingLayout>
  )
}
